import * as tslib_1 from "tslib";
import { Hierarchy } from './hierarchy';
var TreeGrid = /** @class */ (function (_super) {
    tslib_1.__extends(TreeGrid, _super);
    function TreeGrid(param) {
        return _super.call(this, param) || this;
    }
    TreeGrid.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TreeGrid" });
    };
    TreeGrid.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TreeGrid;
}(Hierarchy));
export { TreeGrid };
//# sourceMappingURL=tree_grid.js.map